import Loader from '@component/Loader';

export const PreloaderAnimation = () => (
  <div className="w-full h-full overflow-hidden flex justify-center items-center">
    <div className="max-w-full w-14 h-1">
      <Loader type={Loader.type.BAR} />
    </div>
  </div>
);
